import { render, staticRenderFns } from "./PreQuestion3.vue?vue&type=template&id=15bbd951&"
import script from "./PreQuestion3.vue?vue&type=script&lang=js&"
export * from "./PreQuestion3.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion3.vue?vue&type=style&index=0&id=15bbd951&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports